import { api } from "../HttpService.js";

export const fetchAddress = async (cep) => await api.viaCep.get(`${cep}/json/`);
export const fetchCnpj = async (cnpj) => await api.cnpja.get(`${cnpj}`);
export const fetchRegister = async (cnpj) =>
  await api.minhaReceita.get(`${cnpj}`);
